// Import des hooks nécessaires depuis React
import {useState, FormEvent} from "react";

// Import du type Article (TypeScript)
import {Article} from "../types/Article";

// Définition des props attendues par le composant
interface ArticleFormProps {
  // Fonction fournie par le parent pour ajouter un article
  // On enlève "id" car il sera créé dans le parent
  onAdd: (article: Omit<Article, "id">) => void;
}

// Déclaration du composant ArticleForm
const ArticleForm: React.FC<ArticleFormProps> = ({onAdd}) => {
  // États pour stocker ce que l'utilisateur tape dans les champs
  const [name, setName] = useState(""); // nom de l'article
  const [quantity, setQuantity] = useState(""); // quantité (en texte pour l'input)
  const [unitPrice, setUnitPrice] = useState(""); // prix unitaire (en texte)

  // Fonction appelée quand le formulaire est soumis
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    // Empêche le rechargement de la page
    e.preventDefault();

    // Vérification : tous les champs doivent être remplis
    if (!name.trim() || !quantity || !unitPrice) {
      alert("Veuillez remplir tous les champs");
      return; // on arrête la fonction
    }

    // Conversion des valeurs texte en nombres
    const parsedQuantity = Number(quantity);
    const parsedUnitPrice = Number(unitPrice);

    // Vérification : quantité et prix doivent être > 0
    if (parsedQuantity <= 0 || parsedUnitPrice <= 0) {
      alert("La quantité et le prix doivent être supérieurs à 0");
      return;
    }

    // Création de l'article (sans id)
    const newArticle: Omit<Article, "id"> = {
      nom: name.trim(), // suppression des espaces inutiles
      quantite: parsedQuantity, // quantité en nombre
      prixUnitaire: parsedUnitPrice, // prix unitaire en nombre
    };

    // Envoi de l'article au composant parent
    onAdd(newArticle);

    // Réinitialisation des champs du formulaire
    setName("");
    setQuantity("");
    setUnitPrice("");
  };

  // JSX : ce qui est affiché à l'écran
  return (
    <form className="article-form" onSubmit={handleSubmit}>
      {/* Champ pour le nom de l'article */}
      <input
        type="text"
        placeholder="Nom de l'article"
        value={name}
        onChange={(e) => setName(e.target.value)} // mise à jour de l'état
        required
      />

      {/* Champ pour la quantité */}
      <input
        type="number"
        placeholder="Quantité"
        value={quantity}
        onChange={(e) => setQuantity(e.target.value)}
        min="1"
        required
      />

      {/* Champ pour le prix unitaire */}
      <input
        type="number"
        placeholder="Prix unitaire (€)"
        value={unitPrice}
        onChange={(e) => setUnitPrice(e.target.value)}
        min="0.01"
        step="0.01"
        required
      />

      {/* Bouton pour envoyer le formulaire */}
      <button type="submit">Ajouter</button>
    </form>
  );
};

// Export du composant pour pouvoir l'utiliser ailleurs
export default ArticleForm;
